export const FormatCurrency = (amount) => {
    if (isNaN(amount) || amount === null) return amount;

    amount = Number(amount);

    if (amount >= 1e9) { // Tỉ
        return (Math.floor(amount / 1e9 * 10) / 10) + 'B+';
    } 
    else if (amount >= 1e6) { // Triệu
        return (Math.floor(amount / 1e6 * 10) / 10) + 'M+';
    } 
    else if (amount >= 1e3) { // Nghìn
        return (Math.floor(amount / 1e3 * 10) / 10) + 'K+';
    } 
    else {
        // Trả về số với hàng nghìn nếu nhỏ hơn 1000
        return amount.toLocaleString();
    }
};
